const constructDataCy =
  (devSuffix: string) =>
  (...args: string[]): string =>
    [args.join("-"), devSuffix].join("-");
export default constructDataCy;
